$(document).ready(function () {
  function initGallerySwiper($galleryBox) {
    if (galleryThumbSwiper) {
      galleryThumbSwiper.destroy(true, true);
    }
    if (gallerySwiper) {
      gallerySwiper.destroy(true, true);
    }

    galleryThumbSwiper = new Swiper(
      $galleryBox.find(".main-product_gallery_carousel-thumbs")[0],
      {
        spaceBetween: 10,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
          0: { slidesPerView: 4 },
          1024: { slidesPerView: 7 },
        },
      },
    );

    gallerySwiper = new Swiper(
      $galleryBox.find(".main-product_gallery_carousel")[0],
      {
        spaceBetween: 10,
        navigation: {
          nextEl: $galleryBox.find(".swiper-button-next")[0],
          prevEl: $galleryBox.find(".swiper-button-prev")[0],
        },
        thumbs: { swiper: galleryThumbSwiper },
        on: {
          slideChange: function () {
            var activeSlide = this.slides[this.activeIndex];
            this.slides.forEach(function (slide) {
              var video = slide.querySelector(".mp_carousel-video video");
              if (!video) return;
              if (slide === activeSlide) {
                if (!video.src && video.dataset.src) {
                  video.innerHTML =
                    '<source src="' + video.dataset.src + '" type="video/mp4">';
                  video.load();
                }
                video.play().catch(function () {});
              } else {
                video.pause();
                video.currentTime = 0;
              }
            });
          },
        },
      },
    );
  }

  function filterVariantGallery(currentId) {
    // Carousel layout
    var $carouselTpl = $("template.mp_galleries-config");
    if ($carouselTpl.length) {
      var $source = $($carouselTpl[0].content).find(
        '.main-product_gallerybox[data-id="' + currentId + '"]',
      );
      if (!$source.length) return;
      var $newBox = $source.clone().css("display", "");
      $(".main_product_gallery-box-outer").html($newBox);
      initGallerySwiper($newBox);
      return;
    }

    // Grid layout — separate templates for desktop and mobile
    var $desktopTpl = $("template.mp_grid-desktop-config");
    if ($desktopTpl.length) {
      var $desktopContainer = $($desktopTpl[0].content)
        .find('.main-product_gallery-container[data-id="' + currentId + '"]')
        .clone()
        .css("display", "");
      $(".mpgb_desk").html($desktopContainer);
    }

    var $mobileTpl = $("template.mp_grid-mobile-config");
    if ($mobileTpl.length) {
      var $mobileBox = $($mobileTpl[0].content)
        .find('.main-product_gallerybox[data-id="' + currentId + '"]')
        .clone()
        .css("display", "");
      $(".mpgb_mob").html($mobileBox);
      initGallerySwiper($mobileBox);
    }
  }

  $(".main_product_gallery-box-outer").addClass("loaded");

  var gallerySwiper = null;
  var galleryThumbSwiper = null;

  function initGallerySwiper($galleryBox) {
    if (galleryThumbSwiper) {
      galleryThumbSwiper.destroy(true, true);
    }
    if (gallerySwiper) {
      gallerySwiper.destroy(true, true);
    }

    galleryThumbSwiper = new Swiper(
      $galleryBox.find(".main-product_gallery_carousel-thumbs")[0],
      {
        spaceBetween: 10,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
          0: { slidesPerView: 4 },
          1024: { slidesPerView: 7 },
        },
      },
    );

    gallerySwiper = new Swiper(
      $galleryBox.find(".main-product_gallery_carousel")[0],
      {
        spaceBetween: 10,
        navigation: {
          nextEl: $galleryBox.find(".swiper-button-next")[0],
          prevEl: $galleryBox.find(".swiper-button-prev")[0],
        },
        thumbs: { swiper: galleryThumbSwiper },
        on: {
          slideChange: function () {
            var activeSlide = this.slides[this.activeIndex];
            this.slides.forEach(function (slide) {
              var video = slide.querySelector(".mp_carousel-video video");
              if (!video) return;
              if (slide === activeSlide) {
                if (!video.src && video.dataset.src) {
                  video.innerHTML =
                    '<source src="' + video.dataset.src + '" type="video/mp4">';
                  video.load();
                }
                video.play().catch(function () {});
              } else {
                video.pause();
                video.currentTime = 0;
              }
            });
          },
        },
      },
    );
  }

  function filterVariantGallery(currentId) {
    // Carousel layout
    var $carouselTpl = $("template.mp_galleries-config");
    if ($carouselTpl.length) {
      var $source = $($carouselTpl[0].content).find(
        '.main-product_gallerybox[data-id="' + currentId + '"]',
      );
      if (!$source.length) return;
      var $newBox = $source.clone().css("display", "");
      $(".main_product_gallery-box-outer").html($newBox);
      initGallerySwiper($newBox);
      return;
    }

    // Grid layout — separate templates for desktop and mobile
    var $desktopTpl = $("template.mp_grid-desktop-config");
    if ($desktopTpl.length) {
      var $desktopContainer = $($desktopTpl[0].content)
        .find('.main-product_gallery-container[data-id="' + currentId + '"]')
        .clone()
        .css("display", "");
      $(".mpgb_desk").html($desktopContainer);
    }

    var $mobileTpl = $("template.mp_grid-mobile-config");
    if ($mobileTpl.length) {
      var $mobileBox = $($mobileTpl[0].content)
        .find('.main-product_gallerybox[data-id="' + currentId + '"]')
        .clone()
        .css("display", "");
      $(".mpgb_mob").html($mobileBox);
      initGallerySwiper($mobileBox);
    }
  }

  function setRealReviews() {
    // Check if the element exists and has content
    var content = $(".jdgm-rev-widg__summary-text").html();

    if (content && content.trim().length > 0) {
      console.log("Found content:", content);

      // Extract only the number
      var numberOnly = content.match(/\d+/);
      if (numberOnly) {
        numberOnly = numberOnly[0];
        console.log("Numbers only:", numberOnly);
        $(".ts-product_rating-upd")
          .find("p:not(.ts_product-rating-score)")
          .html(+numberOnly + " Reviews");

        var realRating = parseFloat(
          $(".ts-product_btn_ratings").attr("data-rating"),
        );
        if (realRating > 0) {
          $(".ts-product_btn_ratings")
            .find("p")
            .html(realRating + " Based on " + numberOnly + " reviews");
        } else {
          $(".ts-product_btn_ratings")
            .find("p")
            .html("Based on " + numberOnly + " reviews");
        }
      }

      // Stop interval after success
      clearInterval(window.realReviewChecker);
    }
  }

  // Run the function repeatedly until it finds the element
  window.realReviewChecker = setInterval(setRealReviews, 200);

  function calculateRandomNum() {
    var min = 9;
    var max = 21;
    var randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

    $(".main_product-hurry-number").text(randomNumber);
  }

  calculateRandomNum();

  $(".main-product_tab").click(function () {
    $(this).toggleClass("activeTab");
    $(this).find(".main-product_tab_content").slideToggle();
  });

  $(".product_sticky-atc-btn").click(function () {
    var data = $(this).attr("data");
    // if (data == "scroll") {
    //   $("html, body").animate({ scrollTop: 50 }, 400);
    // } else if (data == "addLoco") {
    //   $(".ts-product__button#TSProductSubmitUpdatedLoco").trigger("click");
    // } else {
    //   $(".ts-product__button#TSProductSubmitSimple").trigger("click");
    //   $(".ts-product__button#TSProductSubmitUpdated").trigger("click");
    //   $(".ts-product__button#TSProductSubmitDigital").trigger("click");
    //   $(".ts-product__button#TSProductSubmitMask").trigger("click");
    //   $(".ts-product__button#TSProductSubmitQuantity").trigger("click");
    // }

    // $(".ts-product__button#TSProductSubmitSimple").trigger("click");
    // $(".ts-product__button#TSProductSubmitUpdated").trigger("click");
    // $(".ts-product__button#TSProductSubmitDigital").trigger("click");
    // $(".ts-product__button#TSProductSubmitMask").trigger("click");
    // $(".ts-product__button#TSProductSubmitQuantity").trigger("click");

    $(this).addClass("adding");
    setTimeout(function () {
      $(".product_sticky-atc-btn").removeClass("adding");
    }, 1000);
    $(".ts-product__button").trigger("click");
  });

  setTimeout(function () {
    $('.mq_block[data="2"]').trigger("click");
  }, 1500);

  $(document).scroll(function () {
    if ($(document).scrollTop() >= 1200) {
      $(".product_sticky-atc").addClass("visible");
    } else {
      $(".product_sticky-atc").removeClass("visible");
    }
  });

  var $stickyAtc = $(".product_sticky-atc");
  if (
    [
      "product.mascara_v13",
      "product.cream-liner_v2",
      "product.peptide-lash-serum_v1",
    ].includes($stickyAtc.data("template"))
  ) {
    var $atcWrapper = $(".ts-product__button-wrapper").first();
    if ($atcWrapper.length) {
      function checkMascaraVisibleMob() {
        var rect = $atcWrapper[0].getBoundingClientRect();
        var inView = rect.bottom > 0 && rect.top < window.innerHeight;
        if (inView) {
          $stickyAtc.removeClass("visibleMob");
        } else {
          $stickyAtc.addClass("visibleMob");
        }
      }
      $(document).on("scroll", checkMascaraVisibleMob);
      checkMascaraVisibleMob();
    } else {
    }
  }

  $(".psa_qty_change").click(function () {
    var mode = $(this).attr("data");

    var limit = $(this).attr("data-limit");

    var currentValue = parseFloat($(".psa_qty_value").html());
    if (mode == "plus") {
      if (limit == "none") {
        currentValue++;
        if (currentValue == 1) {
          $('.mq_block[data="1"]').trigger("click");
        } else if (currentValue == 2) {
          $('.mq_block[data="2"]').trigger("click");
        } else {
          $('.mq_block[data="3"]').trigger("click");
        }
      } else {
        if (currentValue < 3) {
          currentValue++;
          if (currentValue == 1) {
            $('.mq_block[data="1"]').trigger("click");
          } else if (currentValue == 2) {
            $('.mq_block[data="2"]').trigger("click");
          } else {
            $('.mq_block[data="3"]').trigger("click");
          }
        }
      }
    } else {
      if (currentValue > 1) {
        currentValue--;
        if (currentValue == 1) {
          $('.mq_block[data="1"]').trigger("click");
        } else if (currentValue == 2) {
          $('.mq_block[data="2"]').trigger("click");
        } else {
          $('.mq_block[data="3"]').trigger("click");
        }
      }
    }
    $(".psa_qty_value").html(currentValue);

    renderStickyPrices();
  });

  $(document).on("click", function (e) {
    if (!$(e.target).closest(".mpv_box").length) {
      $(".mpv_box").removeClass("active");
      $(".mpv_box").find(".main-product_value_select").slideUp();
    }
  });

  $(".mpv_box").click(function () {
    if ($(this).hasClass("active")) {
      $(".mpv_box").removeClass("active");
      $(".main-product_value_select").slideUp();
    } else {
      $(".mpv_box").removeClass("active");
      $(".main-product_value_select").slideUp();
      $(this).find(".main-product_value_select").slideDown();
      $(this).addClass("active");
    }
    // $(this).toggleClass('active');
  });

  $(".main-product_variants-line.selecting").click(function (evt) {
    var type = $(this).attr("data-type");
    if (type == "bundle") {
      if ($(this).hasClass("oos")) {
      } else {
        var selectedHtml = $(this).html();
        var currentId = $(this).attr("data-id");

        $(this)
          .closest(".mpv_box")
          .find(".main-product_variants-line.mainOne")
          .html(selectedHtml);
        $(this)
          .closest(".mpv_box")
          .find(".main-product_variants-line.mainOne")
          .attr("data-id", currentId);
      }
    } else if (type == "giftcard") {
      if ($(this).hasClass("oos")) {
      } else {
        var selectedHtml = $(this).html();
        var currentId = $(this).attr("data-id");

        var price = $(this).attr("data-price");

        $(".ts-product_digital_price h4").html(price);

        $("#TSProductForm").find('input[name="id"]').attr("value", currentId);
        $("#TSProductSubmitDigital").attr("data-id", currentId);

        $(this)
          .closest(".mpv_box")
          .find(".main-product_variants-line.mainOne")
          .html(selectedHtml);
        $(this)
          .closest(".mpv_box")
          .find(".main-product_variants-line.mainOne")
          .attr("data-id", currentId);
      }
    } else {
      if ($(this).hasClass("oos")) {
      } else {
        // For complete the look
        if ($(this).closest(".product_complete-box").hasClass("box")) {
          var selectedHtml = $(this).html();
          var currentId = $(this).attr("data-id");

          $(this)
            .closest(".main-product_bundle-cell")
            .find(".main-product_bundle_price")
            .addClass("hided");
          $(this)
            .closest(".main-product_bundle-cell")
            .find('.main-product_bundle_price[data-id="' + currentId + '"]')
            .removeClass("hided");

          $(this)
            .closest(".mpv_box")
            .find(".main-product_variants-line.mainOne")
            .html(selectedHtml);
          $(this)
            .closest(".mpv_box")
            .find(".main-product_variants-line.mainOne")
            .attr("data-id", currentId);

          var productBlockId = $(this)
            .closest(".product_complete-line")
            .attr("data-block");

          $('.product_complete-grid-cell[data-block="' + productBlockId + '"]')
            .find(".product_complete-product--variant-image")
            .addClass("hided");

          $(
            '.product_complete-product--variant-image[data-id="' +
              currentId +
              '"]',
          ).removeClass("hided");

          console.log(currentId);

          $(this).closest(".product_complete-line").attr("data-id", currentId);

          calculateCompleteTheLookPrice();
        }
        // For standard selector
        else {
          var selectedHtml = $(this).html();
          var currentId = $(this).attr("data-id");

          $(this)
            .closest(".mpv_box")
            .find(".main-product_variants-line.mainOne")
            .html(selectedHtml);
          $(this)
            .closest(".mpv_box")
            .find(".main-product_variants-line.mainOne")
            .attr("data-id", currentId);

          $(".main-product_gallery-container").hide();
          $(
            '.main-product_gallery-container[data-id="' + currentId + '"]',
          ).show();

          filterVariantGallery(currentId);
        }
      }
    }
  });

  // For masks only
  $(".main-product_variants-line.selecting_mask").click(function (evt) {
    if ($(this).hasClass("oos")) {
    } else {
      var selectedHtml = $(this).html();
      var currentId = $(this).attr("data-id");

      $(this)
        .closest(".mpv_box")
        .find(".main-product_variants-line.mainOne")
        .html(selectedHtml);
      $(this)
        .closest(".mpv_box")
        .find(".main-product_variants-line.mainOne")
        .attr("data-id", currentId);

      var productBlockId = $(this)
        .closest(".product_complete-line")
        .attr("data-block");

      $('.product_complete-grid-cell[data-block="' + productBlockId + '"]')
        .find(".product_complete-product--variant-image")
        .addClass("hided");

      $(
        '.product_complete-product--variant-image[data-id="' + currentId + '"]',
      ).removeClass("hided");

      console.log(currentId);

      $(this).closest(".product_complete-line").attr("data-id", currentId);

      $(this)
        .closest(".product_complete-line")
        .find(".complete_variant--price")
        .addClass("hided");

      $(".complete_variant--price[data-id='" + currentId + "']").removeClass(
        "hided",
      );

      var dataPrice = $(
        ".complete_variant--price[data-id='" + currentId + "']",
      ).attr("data-price");
      var dataFullPrice = $(
        ".complete_variant--price[data-id='" + currentId + "']",
      ).attr("data-full-price");

      $(this).closest(".product_complete-line").attr("data-price", dataPrice);
      $(this)
        .closest(".product_complete-line")
        .attr("data-price-full", dataFullPrice);

      calculateCompleteTheLookPrice();
    }
  });

  $(".mq_block").click(function () {
    $(".mq_block").removeClass("active");
    $(this).addClass("active");
    var data = $(this).attr("data");

    $(".ts-main-quantity_label").val(data);
    $(".ts-main-quantity_label").attr("value", data);

    console.log("data", data);
    $(".psa_quantity-imge").css("display", "none");
    $(".psa_qty_value").html(data);
    if (data == "1") {
      $('.psa_quantity-imge[data="1"]').css("display", "block");
      $(
        ".rbr-page-container > div [class^='style_discount_options_'] > div:nth-child(1) > div",
      ).trigger("click");
    } else if (data == "2") {
      $('.psa_quantity-imge[data="2"]').css("display", "block");
      $(
        ".rbr-page-container > div [class^='style_discount_options_'] > div:nth-child(2) > div",
      ).trigger("click");
    } else if (data == "3") {
      $('.psa_quantity-imge[data="3"]').css("display", "block");
      $(
        ".rbr-page-container > div [class^='style_discount_options_'] > div:nth-child(3) > div",
      ).trigger("click");
    }

    renderStickyPrices();
  });

  $(".mpq_cell-box").click(function () {
    $(".mpq_cell-box").removeClass("active");
    $(this).addClass("active");
    var data = $(this).attr("data");
    $(".ts-main-quantity_label").val(data);
    $(".ts-main-quantity_label").attr("value", data);

    console.log("data", data);
    if (data == "1") {
      $(".product_freebies-box.dynamicBox").removeClass("active");
      $(
        ".rbr-page-container > div [class^='style_discount_options_'] > div:nth-child(1) > div",
      ).trigger("click");
    } else if (data == "2") {
      $(".product_freebies-box.dynamicBox").addClass("active");
      $(
        ".rbr-page-container > div [class^='style_discount_options_'] > div:nth-child(2) > div",
      ).trigger("click");
    } else if (data == "3") {
      $(".product_freebies-box.dynamicBox").addClass("active");
      $(
        ".rbr-page-container > div [class^='style_discount_options_'] > div:nth-child(3) > div",
      ).trigger("click");
    }
  });

  $(".ts-product_rating-upd").click(function (evt) {
    evt.preventDefault();
    const target = $(".jdgm-rev-widg__header");
    if (!target.length) return;
    const preferredOffset = Number($(this).data("offset")) || 100;
    const offset = target.offset().top - preferredOffset;
    $("html, body").animate({ scrollTop: offset }, 400);
  });

  $(".main-product_color_swatch").click(function () {
    $(".main-product_color_swatch").removeClass("active");
    $(this).addClass("active");

    var currentId = $(this).attr("data-id");
    $("#TSProductForm").find('input[name="id"]').attr("value", currentId);

    $(".main-product_gallery-container").hide();
    $('.main-product_gallery-container[data-id="' + currentId + '"]').show();

    filterVariantGallery(currentId);

    var availability = $(this).attr("data-available");
    if (availability == "true") {
      $(".ts_product-btn-text").html("Add to cart");
      $(".ts-product__button").removeClass("disabled");
      $(".klaviyo-bis-trigger").addClass("disabled");
      $(".klaviyo-bis-trigger").hide();
      $("#TSProductSubmitUpdated").show();
    } else {
      $(".ts_product-btn-text").html("Sold out");
      $(".ts-product__button").addClass("disabled");
      $(".klaviyo-bis-trigger").removeClass("disabled");
      $(".klaviyo-bis-trigger").show();
      $("#TSProductSubmitUpdated").hide();
    }
    renderStickyPrices();

    var currentImg = $(this).find(".mp_bubble-image--js").attr("src");
    var variantTitle = $(this).find(".mpc_label").find("p").html();

    $(".main-product_variants-line.mainOne").each(function () {
      $(this).attr("data-id", currentId);
      $(this).find("p").html(variantTitle);
      $(this).find(".mpvl_bubble").find("img").attr("src", currentImg);
    });
  });

  // $(".klaviyo-bis-trigger").click(function () {
  //   $("#klaviyo-bis-iframe").show();
  //   $("#klaviyo-bis-iframe").css("background", "rgba(0, 0, 0, 0.7)");
  // });

  $(".klaviyo-bis-trigger").click(function (e) {
    e.preventDefault();

    var variantId = $(".simple-product_shade.active").attr("data-id");

    $("#klaviyo-bis-iframe").show().css("background", "rgba(0, 0, 0, 0.7)");
  });

  $(".mpq_cell-box.active").trigger("click");

  $(".product_btn-primary").click(function (evt) {
    evt.preventDefault();

    $("html, body").animate(
      {
        scrollTop: $(".ts-product__info").offset().top - 200,
      },
      500,
    );
  });

  $("#TSProductSubmitVip").click(function (evt) {
    $(".ts-product__button").find(".ts-product__loading").css("opacity", "1");
    setTimeout(function () {
      $(".ts-product__button").find(".ts-product__loading").css("opacity", "0");
    }, 2000);
    evt.preventDefault();

    var items = [];
    var currentId = $(this).attr("data-id");
    var currentQty = 1;
    var sellingPlan = $(".main_product-sub-selector-line.active").attr(
      "data-id",
    );

    items.push({
      id: currentId,
      quantity: currentQty,
      selling_plan: sellingPlan,
    });

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        items: items,
      },
      dataType: "json",
      success: function () {
        jQuery.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: { attributes: { discount_code: "testing12345609887" } }, // 🔁 replace SAVE10
          dataType: "json",
          success: function () {
            console.log("Discount code stored in cart attributes");
            window.refreshCartDrawer(false, null);
            window.openCartDrawer(true);
          },
        });
      },
      error: function () {},
    });
  });

  $("#TSProductSubmitDigital").click(function (evt) {
    $(".ts-product__button").find(".ts-product__loading").css("opacity", "1");
    setTimeout(function () {
      $(".ts-product__button").find(".ts-product__loading").css("opacity", "0");
    }, 2000);
    evt.preventDefault();

    var items = [];
    var currentId = $(this).attr("data-id");
    var currentQty = 1;

    items.push({ id: currentId, quantity: currentQty });

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        items: items,
      },
      dataType: "json",
      success: function () {
        jQuery.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: { attributes: { discount_code: "testing12345609887" } }, // 🔁 replace SAVE10
          dataType: "json",
          success: function () {
            console.log("Discount code stored in cart attributes");
            window.refreshCartDrawer(false, null);
            window.openCartDrawer(true);
          },
        });
      },
      error: function () {},
    });
  });

  $(".main-productBundleAtc").click(function (evt) {
    evt.preventDefault();

    $(".ts-product__button").find(".ts-product__loading").css("opacity", "1");
    setTimeout(function () {
      $(".ts-product__button").find(".ts-product__loading").css("opacity", "0");
    }, 2000);

    var items = [];

    var bundleName = $(this).attr("data-title-prop");
    $(".main-product_variants-line.mainOne").each(function () {
      var currentId = $(this).attr("data-id");
      var currentQty = 1;
      items.push({
        id: currentId,
        quantity: currentQty,
        properties: { Bundle: bundleName },
      });
    });

    console.log(items);

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        items: items,
      },
      dataType: "json",
      success: function () {
        window.refreshCartDrawer(false, null);
        window.openCartDrawer(true);
      },
      error: function () {},
    });
  });

  $("#TSProductSubmitMask").click(function (evt) {
    evt.preventDefault();

    $(".ts-product__button").find(".ts-product__loading").css("opacity", "1");
    setTimeout(function () {
      $(".ts-product__button").find(".ts-product__loading").css("opacity", "0");
    }, 2000);

    var mode = $(".main-product_sub_switch.active").attr("data");

    var items = [];
    $(".mq_block.active").each(function () {
      var currentId = $(this).attr("data-id");
      var currentQty = 1;
      var selling_plan = $(this).attr("data-selling_plan");

      if (mode == "sub") {
        items.push({
          id: currentId,
          quantity: currentQty,
          selling_plan: selling_plan,
        });
      } else {
        items.push({ id: currentId, quantity: currentQty });
      }
    });

    $(".mq_block.active")
      .find(".mq_block-gift-product")
      .each(function () {
        var currentId = $(this).attr("data-id");
        items.push({ id: currentId, quantity: 1 });
      });

    console.log(items);

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        items: items,
      },
      dataType: "json",
      success: function () {
        window.refreshCartDrawer(false, null);
        window.openCartDrawer(true);
      },
      error: function () {},
    });
  });

  $("#TSProductSubmitQuantity").click(function (evt) {
    evt.preventDefault();

    var $wrapper = $(this).closest(".ts-product__wrapper");

    $wrapper
      .find(".ts-product__button")
      .find(".ts-product__loading")
      .css("opacity", "1");
    setTimeout(function () {
      $wrapper
        .find(".ts-product__button")
        .find(".ts-product__loading")
        .css("opacity", "0");
    }, 2000);

    var items = [];

    var currentId = $wrapper
      .find(".simple-product_shade.active")
      .attr("data-id");
    var currentQty = parseFloat(
      $wrapper.find(".product_main-atc-qty-box").find(".psa_qty_value").html(),
    );

    var selling_plan = "";
    if (
      $wrapper
        .find('.main_product-sub-selector-line[data="sub"]')
        .hasClass("active")
    ) {
      selling_plan = $wrapper
        .find('.main_product-sub-selector-line[data="sub"]')
        .attr("data-id");
    }

    items.push({
      id: currentId,
      quantity: currentQty,
      selling_plan: selling_plan,
    });

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: items, sections: "cell_cart_drawer" }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to add to cart");
        return res.json();
      })
      .then((data) => {
        window.refreshCartDrawer(false, data.sections);
        window.openCartDrawer(true);
      })
      .catch((err) => console.error("Error:", err));
  });

  $("#TSProductSubmitSimple").click(function (evt) {
    evt.preventDefault();

    var $wrapper = $(this).closest(".ts-product__wrapper");

    $wrapper
      .find(".ts-product__button")
      .find(".ts-product__loading")
      .css("opacity", "1");
    setTimeout(function () {
      $wrapper
        .find(".ts-product__button")
        .find(".ts-product__loading")
        .css("opacity", "0");
    }, 2000);

    var items = [];
    $wrapper
      .find(".mq_block.active")
      .find(".main-product_variants-line.mainOne")
      .each(function () {
        var currentId = $(this).attr("data-id");
        var currentQty = 1;

        items.push({ id: currentId, quantity: currentQty });
      });

    $wrapper
      .find(".mq_block.active")
      .find(".mq_block-gift-product")
      .each(function () {
        var currentId = $(this).attr("data-id");
        items.push({ id: currentId, quantity: 1 });
      });

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: items, sections: "cell_cart_drawer" }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to add to cart");
        return res.json();
      })
      .then((data) => {
        window.refreshCartDrawer(false, data.sections);
        window.openCartDrawer(true);
      })
      .catch((err) => console.error("Error:", err));
  });

  // $(".product_complete-line").click(function (e) {
  //   // Do nothing if the click came from variants inside the line
  //   if ($(e.target).closest(".product_complete_line-variants").length) {
  //     return;
  //   }

  //   calculateCompleteTheLookPrice();

  //   $(this).toggleClass("active");
  // });

  function calculateCompleteTheLookPrice() {
    setTimeout(function () {
      var totalPrice = 0;
      var comparePrice = 0;

      $(".product_complete-box")
        .find(".main-product_bundle_price:not(.hided)")
        .each(function () {
          var currentPrice = parseFloat($(this).attr("data-price"));
          var currentFullPrice = parseFloat($(this).attr("data-compare"));
          totalPrice = totalPrice + currentPrice;
          comparePrice = comparePrice + currentFullPrice;
        });

      totalPrice = totalPrice.toFixed(2);
      comparePrice = comparePrice.toFixed(2);

      console.log(totalPrice, "TOTAL PRICE IS");

      $(".product_complete-look-price").html(
        "<s>$" + comparePrice + "</s><span>$" + totalPrice + "</span>",
      );
    }, 100);
  }

  // Upsell mer

  $(".mpm_upsell-switch").click(function () {
    $(".mpm_upsell-switch").removeClass("active");
    $(this).addClass("active");
    var data = $(this).attr("data");

    $(".mpm_upsell-list").addClass("hided");
    $('.mpm_upsell-list[data="' + data + '"]').removeClass("hided");
  });

  $(".mpm_upsell-card-btn").click(function () {
    $(this).addClass("adding");
    window._cartTimingStart = Date.now();
    window._cartTimingAction = "mpm_upsell_card";
    var dataRealBundle = $(this)
      .closest(".mpm_upsell-card")
      .find(".mpm_real-bundle-config")
      .attr("data-real-bundle");

    if (dataRealBundle == "true") {
      var currentQty = 1;

      var items = [];

      var bundleName = $(this).attr("data-bundle");

      $(this)
        .closest(".mpm_upsell-card")
        .find(".mpm_real-bundle-config")
        .each(function () {
          var currentId = $(this).attr("data-id");
          items.push({
            id: currentId,
            quantity: currentQty,
            properties: { Bundle: bundleName },
          });
        });
    } else {
      var currentId = $(this).attr("data-id");
      var currentQty = 1;

      var items = [];

      items.push({ id: currentId, quantity: currentQty });
    }

    console.log(items);

    window._cartApiStart = Date.now();
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        items: items,
      },
      dataType: "json",
      success: function (data) {
        $(".mpm_upsell-card-btn").removeClass("adding");
        window.refreshCartDrawer(false, data.sections);
        window.openCartDrawer(true);
      },
      error: function () {
        $(".mpm_upsell-card-btn").removeClass("adding");
        window.refreshCartDrawer(false, null);
        window.openCartDrawer(true);
      },
    });
  });

  $("#TSProductSubmitUpdated").click(function () {
    $(".ts-product__button").find(".ts-product__loading").css("opacity", "1");
    setTimeout(function () {
      $(".ts-product__button").find(".ts-product__loading").css("opacity", "0");
    }, 2000);

    var currentQty = parseFloat($(".mq_block.active").attr("data"));
    var currentId = $(".main-product_color_swatch.active").attr("data-id");

    data = {
      id: currentId,
      quantity: currentQty,
    };

    var items = [];

    items.push({ id: currentId, quantity: currentQty });

    // $('.mq_block.active').find('.mq_block-infogift').each(function(){
    //   var currentGiftId = $(this).attr('data-id');
    //   items.push({ id: currentGiftId , quantity: 1 });
    // });

    console.log(items);

    $(".mq_block.active")
      .find(".mq_block-gift-product")
      .each(function () {
        var currentId = $(this).attr("data-id");
        items.push({ id: currentId, quantity: 1 });
      });

    // Add the items to the cart
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        items: items,
      },
      dataType: "json",
      success: function () {
        window.refreshCartDrawer(false, null);
        window.openCartDrawer(true);
      },
      error: function () {},
    });
  });

  $("#TSProductSubmitUpdatedLoco").click(function () {
    $(".ts-product__button").find(".ts-product__loading").css("opacity", "1");
    setTimeout(function () {
      $(".ts-product__button").find(".ts-product__loading").css("opacity", "0");
    }, 2000);

    var currentQty = 1;
    var currentId = $(".mq_block.active").attr("data-product-var-id");

    data = {
      id: currentId,
      quantity: currentQty,
    };

    console.log(data);
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {},
      error: function () {},
    });

    var items = [];

    items.push({ id: currentId, quantity: currentQty });

    // $('.mq_block.active').find('.mq_block-infogift').each(function(){
    //   var currentGiftId = $(this).attr('data-id');
    //   items.push({ id: currentGiftId , quantity: 1 });
    // });

    console.log(items);

    // Add the items to the cart
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        items: items,
      },
      dataType: "json",
      success: function () {
        window.refreshCartDrawer(false, null);
        window.openCartDrawer(true);
      },
      error: function () {},
    });
  });

  var $initialGalleryBox = $(
    ".main_product_gallery-box-outer .main-product_gallerybox",
  );
  if ($initialGalleryBox.length) {
    initGallerySwiper($initialGalleryBox);
  }

  const swiper = new Swiper(".product_reviews-carousel", {
    slidesPerView: 3,
    spaceBetween: 20,
    navigation: {
      nextEl: ".product_reviews-car .swiper-button-next",
      prevEl: ".product_reviews-car .swiper-button-prev",
    },
    loop: true,
    grabCursor: true,
    breakpoints: {
      // Optional: responsive behavior
      0: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
    },
  });

  const swiperResults = new Swiper(".product_results-carousel", {
    slidesPerView: 4,
    spaceBetween: 16,
    navigation: {
      nextEl: ".product_results-car .swiper-button-next",
      prevEl: ".product_results-car .swiper-button-prev",
    },
    loop: true,
    grabCursor: true,
    breakpoints: {
      0: {
        slidesPerView: 1.2, // show a bit of the next slide
        spaceBetween: 16,
        slidesOffsetBefore: 32, // left side offset
        slidesOffsetAfter: 32, // right side offset
      },
      768: {
        slidesPerView: 3,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
      1024: {
        slidesPerView: 4,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
    },
  });

  $(".simple-product_shade").click(function () {
    if ($(this).closest(".pu_outer").length) return;
    $(".simple-product_shade").removeClass("active");
    $(this).addClass("active");
    var variantId = $(this).attr("data-id");
    $(".main-product_gallery-container").hide();
    $('.main-product_gallery-container[data-id="' + variantId + '"]').show();

    filterVariantGallery(variantId);

    var variantTitle = $(this).attr("data-title");
    $(".simple-product_shades_info__js").html(variantTitle);

    if ($(this).hasClass("simple-product_shade_unavailable")) {
      $(".klaviyo-bis-trigger").show();
      $("#TSProductSubmitSimple").hide();
      $("#TSProductSubmitQuantity").hide();
    } else {
      $(".klaviyo-bis-trigger").hide();
      $("#TSProductSubmitSimple").show();
      $("#TSProductSubmitQuantity").show();
    }

    var currentImg = $(this).find(".simple-product_shade-icon").attr("src");

    // $(".main-product_variants-line.mainOne").each(function () {
    //   $(this).attr("data-id", variantId);
    //   $(this).find("p").html(variantTitle);
    //   $(this).find(".mpvl_bubble").find("img").attr("src", currentImg);
    // });

    if ($(this).hasClass("simple-product_shade_unavailable")) {
      $(".mq_block-badge-for-notsoldout").addClass("hided");
      $(".mq_block-badge-for-soldout").removeClass("hided");
      $(".mq_block").addClass("soldout");
    } else {
      $(".mq_block-badge-for-notsoldout").removeClass("hided");
      $(".mq_block-badge-for-soldout").addClass("hided");
      $(".mq_block").removeClass("soldout");
    }
  });

  function getNumberFromPrice(priceStr) {
    return parseFloat(priceStr.replace(/[^0-9.]/g, ""));
  }

  function formatLikeOriginal(original, number) {
    const symbolMatch = original.match(/[^0-9.,]+/g);
    const symbol = symbolMatch ? symbolMatch[0] : "";

    const hasCommaDecimal = original.includes(",");

    // Format number using proper locale
    let formatted = hasCommaDecimal
      ? number.toFixed(2).replace(".", ",") // European decimal
      : number.toFixed(2); // US/UK decimal

    // Return with symbol at start OR end
    if (original.trim().startsWith(symbol)) {
      return symbol + formatted;
    } else {
      return formatted + symbol;
    }
  }

  function writeCorrectPriceSticky(realPrice, comparePrice) {
    $(".product_sticky-real-price--js").html(realPrice);
    $(".product_sticky-compare-price--js").html(comparePrice);

    if ($(".psa_qty_value").length > 0) {
      var quantity = parseFloat($(".psa_qty_value").html());
      var realNum = realPrice ? getNumberFromPrice(realPrice) : 0;
      var newPrice = realNum * quantity;

      var realCompNum = comparePrice ? getNumberFromPrice(comparePrice) : 0;

      var newCompPrice = realCompNum * quantity;

      // Format new price like old one
      var formattedPrice = formatLikeOriginal(realPrice, newPrice);

      // Format compare price ONLY if it exists
      var formattedComparePrice = comparePrice
        ? formatLikeOriginal(comparePrice, newCompPrice)
        : "";

      $(".ts_product-atc-btn--price").html(
        "<s>" + formattedComparePrice + "</s>" + formattedPrice,
      );
      $(".ts_product-atc-btn--price_mask").html(formattedPrice);
    } else {
      $(".ts_product-atc-btn--price").html(
        "<s>" + comparePrice + "</s>" + realPrice,
      );
      $(".ts_product-atc-btn--price_mask").html(
        "<s>" + comparePrice + "</s>" + realPrice,
      );
    }
  }

  function renderStickyPrices() {
    var realPrice, comparePrice;

    if ($(".main-product_quantity").attr("data") == "masks") {
      var mode = $(".main-product_sub_switch.active").attr("data");
      if (mode == "sub") {
        realPrice = $(".mq_block.active").attr("data-price-sub");
        comparePrice = $(".mq_block.active .mq_block-price").find("s").html();
      } else {
        realPrice = $(".mq_block.active").attr("data-price-otp");
        comparePrice = $(".mq_block.active .mq_block-price").find("s").html();
      }
    } else {
      if ($(".ts-product_digital_price").length) {
        realPrice = $(".ts_product_price-box.active")
          .find(".ts-product_digital_price")
          .find("h4")
          .html();
        comparePrice = $(".ts_product_price-box.active")
          .find(".ts-product_digital_price")
          .find("s")
          .html();
      } else if ($(".mq_block.active .mq_block-price").length) {
        realPrice = $(".mq_block.active .mq_block-price").find("span").html();
        comparePrice = $(".mq_block.active .mq_block-price").find("s").html();
      } else if ($(".ts-product_bundle_price").length) {
        realPrice = $(".ts-product_bundle_price").find("span").html();
        comparePrice = $(".ts-product_bundle_price").find("s").html();
      } else if ($(".ts-product__price").length) {
        realPrice = $(".ts-product__price").find("span").html();
        comparePrice = $(".ts-product__price").find("s").html();
      } else {
        realPrice = null;
        comparePrice = null;
      }
    }

    console.log(realPrice, "REAL PRICE IS ==== ");

    writeCorrectPriceSticky(realPrice, comparePrice);
  }

  renderStickyPrices();

  $(".main-product_sub_switch").click(function () {
    $(".main-product_sub_switch").removeClass("active");
    $(this).addClass("active");
    var data = $(this).attr("data");
    if (data == "sub") {
      $(".content_dynamic-otp").hide();
      $(".content_dynamic-sub").show();
    } else {
      $(".content_dynamic-otp").show();
      $(".content_dynamic-sub").hide();
    }

    renderStickyPrices();
  });

  $(".main_product-sub-selector-line").click(function () {
    $(".main_product-sub-selector-line").removeClass("active");
    $(this).addClass("active");
    var currentMode = $(this).attr("data");
    if (currentMode == "sub") {
      $('.ts_product_price-box[data="otp"]').addClass("hided");
      $('.ts_product_price-box[data="sub"]').removeClass("hided");
      $('.ts_product_price-box[data="otp"]').removeClass("active");
      $('.ts_product_price-box[data="sub"]').addClass("active");
      $(".main_product-sub-delivery-frequency").addClass("visible");
    } else {
      $('.ts_product_price-box[data="otp"]').removeClass("hided");
      $('.ts_product_price-box[data="sub"]').addClass("hided");
      $('.ts_product_price-box[data="otp"]').addClass("active");
      $('.ts_product_price-box[data="sub"]').removeClass("active");
      $(".main_product-sub-delivery-frequency").removeClass("visible");
    }

    renderStickyPrices();
  });

  $(".main_product-sub-delivery-select_thumb").click(function () {
    $(this).toggleClass("active");
    $(".main_product-sub-delivery-select_content").slideToggle();
  });

  $(".main_product-sub-delivery-select-val").click(function () {
    var currentVal = $(this).html();
    var currentId = $(this).attr("data-id");
    $('.main_product-sub-selector-line[data="sub"]').attr("data-id", currentId);
    $(".main_product-sub-delivery-select_thumb").find("p").html(currentVal);
    $(".main_product-sub-delivery-select_content").slideUp();
    $(".main_product-sub-delivery-select_thumb").removeClass("active");
  });

  $(document).click(function (e) {
    // If click is NOT inside the component
    if (!$(e.target).closest(".main_product-sub-delivery-select").length) {
      $(".main_product-sub-delivery-select_content").slideUp();
      $(".main_product-sub-delivery-select_thumb").removeClass("active");
    }
  });

  $(window).on("scroll", function () {
    if ($(window).scrollTop() >= 500) {
      var $video = $(".pr_video_chemical");
      if ($video.length && !$video.attr("src")) {
        $video.attr("src", $video.data("src"));
      }
      $video[0].play();
      $(window).off("scroll");
    }
  });
});
